import { Box } from '@mui/material'
import { styles } from './styles'

export const RemindersList = () => {
  return <Box sx={styles.noReminders}>Нет напоминаний</Box>
}
